import { toast } from 'react-toastify';

import { forEach, isEmpty, isString } from 'lodash';

const DEFAULT_ERROR_MESSAGE = 'Error occurred.';

export const getErrorMessage = ({error}: {error: string}) => {
  if (isString(error)) {
    return error;
  } else {
    return "Something went wrong"
  }
  
};

interface MessageOptions {
  message: string, options?: any
}

export const notifyInfo = ({message, options = {}}: MessageOptions) => toast.info(message, options);

export const notifyWarning = ({ message, options = {} }: MessageOptions) =>
  toast.warning(message, options);

export const notifySuccess = ({ message, options = {} }: MessageOptions) =>
  toast.success(message, options)
;

export const notifyError = ({error, options = {}}: {error: string, options?: any}) => {
  toast.error(getErrorMessage(({error})), options);
};

export const notifyErrors = ({errors, options = {}}: {errors: Array<string>, options?: any}) => {
  if (isEmpty(errors)) {
    notifyError({error: DEFAULT_ERROR_MESSAGE});
    return;
  }

  forEach(errors, (e) => notifyError({error: e, options}));
};

export const dismissNotification = (toastId: number) => toast.dismiss(toastId);
